module.exports = __webpack_public_path__ + "static/media/nismLocationMaster.4183b999.xlsx";